import type { InputTypeMap } from "@mui/base/Input";
import { Input } from "@mui/base/Input";
import type { FunctionComponentWithRef } from "react";

import { StyledInput as input, Root as root } from "scmp-app/components/common/base-input/styles";

export type Props = InputTypeMap["props"];

export const BaseInput: FunctionComponentWithRef<Props, HTMLInputElement> = ({
  ref: forwardReference,
  slots,
  ...props
}) => <Input slots={{ input, root, ...slots }} {...props} ref={forwardReference} />;

BaseInput.displayName = "BaseInput";
